import * as Yup from 'yup'
import { emailSchema } from './email.validation'

const signInSchema = Yup.object().shape({
  email: emailSchema.required('validation-required'),
  password: Yup.string()
    .required('validation-required')
    .min(8, 'validation-password-min')
    .max(250, 'validation-password-max'),
})
export { signInSchema }
